





























import { EventInterface, PersistedEventInterface } from "@/types";
import Event from "@/classes/Event";
import Vue from "vue";
import Component from "vue-class-component";
@Component({
  components: {},
})
export default class NextEvent extends Vue {
  private header: string = "NEXT EVENT";
  private nextEvent?: PersistedEventInterface | false = false;

  get truncatedDescription(): string {
    if (!this.nextEvent || !this.nextEvent.description) {
      return "";
    }
    const plain = this.nextEvent.description.replace(/[#*_~`>\[\]()!]/g, "").trim();
    return plain.length > 500 ? plain.substring(0, 500).trimEnd() + "..." : plain;
  }

  public async getNextMainEvent() {
    const today = new Date().toISOString().substring(0, 10);
    const response = await this.axios.get("/arma/events", {
      params: {
        "mainEvent": "1",
        "sort[asc]": "date",
        "date[gte]": today,
      },
    });

    return new Event(response.data[0]);
  }

  public async mounted() {
    this.nextEvent = await this.getNextMainEvent();
  }
}
